import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isEditAllocationRequestFailure({ uuid }) {
      const state = getState().find(
        ({ allocation }) => uuid === allocation.uuid,
      );

      return state ? state.request.isFailure : false;
    },
    isEditAllocationRequestPending({ uuid }) {
      const state = getState().find(
        ({ allocation }) => uuid === allocation.uuid,
      );

      return state ? state.request.isPending : false;
    },
    isEditAllocationRequestSuccess({ uuid }) {
      const state = getState().find(
        ({ allocation }) => uuid === allocation.uuid,
      );

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
